import { FLAG_COLORS } from '../../../../constants/flagStyle'
import { FlagEnum } from '../../../../models/flags'
import { Cursors } from '../../../types'
import { Workspace } from '../../toolBoxes/2D'

const show2DFlagTooltip = (workspaceTool: Workspace): (() => void) =>
    function showFlagTooltip(this: paper.Item) {
        if (workspaceTool.currentActiveCursor === Cursors.GRABBING) return

        workspaceTool.setFlagTooltip({
            visible: true,
            flagId: this.data.flag_id,
        })

        const flagType = this.data.type || FlagEnum.TASK
        const hoverColor = FLAG_COLORS[flagType]?.hoverColor || FLAG_COLORS[FlagEnum.TASK].hoverColor

        if (!this.data.originalColor) {
            const originalType = this.data.type || FlagEnum.TASK

            this.data.originalColor = FLAG_COLORS[originalType]?.color || FLAG_COLORS[FlagEnum.TASK].color
        }

        if (this.children && this.children.length > 0) {
            const flagCompound = this.children[0]

            if (flagCompound && flagCompound.fillColor !== undefined) {
                flagCompound.fillColor = hoverColor
            }
        }
    }

const hide2DFlagTooltip = (workspaceTool: Workspace): (() => void) =>
    function hideFlagTooltip(this: paper.Item) {
        if (workspaceTool.currentActiveCursor === Cursors.GRABBING) return

        workspaceTool.setFlagTooltip({
            visible: false,
            flagId: null,
        })

        const originalColor = this.data.originalColor || FLAG_COLORS[FlagEnum.TASK].color

        if (this.children && this.children.length > 0) {
            const flagCompound = this.children[0]

            if (flagCompound && flagCompound.fillColor !== undefined) {
                flagCompound.fillColor = originalColor
            }
        }
    }

export default function addTooltipsToFlag(path: paper.Item, workspaceTool: Workspace): void {
    path.onMouseEnter = show2DFlagTooltip(workspaceTool).bind(path)

    path.onMouseLeave = hide2DFlagTooltip(workspaceTool).bind(path)
}
